<script setup lang="ts">
import { ArrowPathIcon } from '@heroicons/vue/24/outline'
defineProps(['params'])
</script>

<template>
  <div class="flex items-center gap-2 w-full">
    <button
      class="btn btn-ghost btn-sm"
      title="Relancer la synchro (re-check Odoo + lettrage CEGID)"
      :disabled="params.isRetrying && params.isRetrying(params.data.invoiceUuid)"
      @click="params.onRetry(params.data)"
    >
      <ArrowPathIcon
        class="w-4 h-4"
        :class="{ 'animate-spin': params.isRetrying && params.isRetrying(params.data.invoiceUuid) }"
      />
    </button>
  </div>
</template>
